export const ADD_LICENSE = "add_user";
export const ADD_LICENSE_SUCCESSFUL = "add_user_successful";
export const ADD_LICENSE_FAILED = "add_user_error";

export const GET_LICENSE = "get_license";
export const GET_LICENSE_FAILED = "get_license_failed";
export const GET_LICENSE_SUCCESSFUL = "get_license_successful";

export const UPDATE_LICENSE = "update_license";
export const UPDATE_LICENSE_SUCCESSFUL = "update_license_successful";
export const UPDATE_LICENSE_FAILED = "update_license_failed";

export const ADD_COMPLIANCE_ADDONS = "add_compliance_addons";
export const ADD_COMPLIANCE_ADDONS_SUCCESSFUL = "add_compliance_addons_successful";
export const ADD_COMPLIANCE_ADDONS_FAILED = "add_compliance_addons_failed";

export const DELETE_LICENSE = "delete_cognito_user";
export const DELETE_LICENSE_SUCCESSFUL = "delete_cognito_user_successful";
export const DELETE_LICENSE_FAILED = "delete_cognito_user_failed";

export const CLEAR_ALL_MESSAGES = "clear_all_messages";
export const CLEAR_ALL_MESSAGES_SUCCESS = "clear_all_messages_success";

export const CLEAR_SUCCESS_MESSAGES = "clear_success_messages";
export const CLEAR_SUCCESS_MESSAGES_SUCCESS = "clear_success_messages_success";

export const CLEAR_FAILURE_MESSAGES = "clear_failure_messages";
export const CLEAR_FAILURE_MESSAGES_SUCCESS = "clear_failure_messages_success";

